import { statusCategoryForId } from '@jira/platform__status-categories/src/status-categories.tsx';
import type { ServerRestStatus } from '@atlassian/jira-issue-shared-types/src/common/types/status-type.tsx';
import type { Status } from '../types.tsx';

export const transformServerRestStatusToStatus = (serverResStatus: ServerRestStatus): Status => {
	return {
		id: serverResStatus?.id ?? '',
		statusName: serverResStatus?.name ?? '',
		statusCategory: statusCategoryForId(serverResStatus?.statusCategory?.id),
	};
};
